'use strict';

var base = require('./base');
var isRecommadationInjected = true;
var isDataPushed = false;
/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

function openStoreAvailabilityTab() {
    $('.pdp-ship-callout a').on('click', function () {
        let $storeTab = $('#tab-D'),
            $storeAccordion = $('#heading-D button');
        if ($storeAccordion.length && $(window).width() < 1024) {
            $storeAccordion.trigger('click');
        } else if ($storeTab.length && $(window).width() >= 1024) {
            $storeTab.trigger('click');
        }
    });
}

function showNotification(data, duration) {
    const $notification = $('.notification');
    const $notificationMessage = $('.showMessage');
    const $alert = $('.alert');
    $notificationMessage.text(data.msg);
    if (data.errorMessage) {
        $notificationMessage.text(data.errorMessage);
        $alert.addClass('alert-danger');
    }
    $notification.removeClass('d-none').addClass('show');
    setTimeout(function () {
        $notification.addClass('d-none').removeClass('show');
        $alert.removeClass('alert-danger alert-success');
    }, duration);
}

function subscriberFormReset() {
    $('.subscription-form').trigger('reset');
    $('#productSubscribe').attr('disabled', 'disabled');
}

function includeInYourGift() {
    $('input[name="stuffFull-radio"]').on('click', function () {
        const $packagingOption = $(this).parents('.packaging-option');
        const $dressOption = $packagingOption.next('.dress-option');
        if ($("#unstuffed").is(":checked")) {
            $dressOption.addClass('d-none');
        } else {
            $dressOption.removeClass('d-none');
        }
    });
}

$(document).ready(function () {
    includeInYourGift();
    openStoreAvailabilityTab();
    base.addToBuilder();
    if ($('.youtube_player').length == 1) {
        $('.youtube_player').append($('#youtube_video'));
        $('#youtube_video').height($('.youtube_player').parent().height()).removeClass('d-none');
        $('.youtube-thumb, .swiper-scrollbar-horizontal').on('click touchmove', function () {
            // height can be 0 if lazy loading images are slow
            if ($('#youtube_video').height() < 100) {
                $('#youtube_video').height($('.youtube_player').parent().height());
            }
        });
    }
});

function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

function giftMessageFormClear(form) {
    form.removeClass('is-invalid');
    form.next('.invalid-feedback').text('');
}

function viewDataGTM(recommendationContainer) {
    const observer = new IntersectionObserver((entries) => { // eslint-disable-line
        if (entries[0].isIntersecting && !isDataPushed) {
            var dataset = $(entries[0].target).find('.product-tile-container').find('.image-container > a');
            var obj = {
                event: 'view_item_list',
                ecommerce: {
                    currency: '',
                    items: []
                }
            };
            $(dataset).each((index, entry) => {
                var gtmData = $(entry).data('gtm');
                obj.ecommerce.currency = gtmData.ecommerce.currency;
                obj.ecommerce.items.push(gtmData.ecommerce.items[0]);
            });
            window.dataLayer.push(obj);
            isDataPushed = true;
        }
    });
    observer.observe(recommendationContainer[0]);
}

$('body').on('click', '.image-container-url', function () {
    // select_item: BW-4650
    window.dataLayer.push($(this).data('gtm'));
});

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,
    // addToCart: base.addToCart,
    images: base.images,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function (e) {
            e.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    subscriberTerms: function () {
        $('#subscriberEmail, #subscriberTerms').on('input change', function () {
            let email = $('#subscriberEmail').val();
            let isChecked = $('#subscriberTerms').is(':checked');

            if (isValidEmail(email) && isChecked) {
                $('#productSubscribe').prop('disabled', false);
            } else {
                $('#productSubscribe').prop('disabled', true);
            }
        });

        function isValidEmail(email) {
            var emailPattern = /^([\w+\-]+\.)*[\w+\-]+@([\w+\-]+\.)*[\w+\-]+\.[a-zA-Z]{2,4}$/;
            return emailPattern.test(email);
        }
    },
    productSubscribe: function () {
        $('body').on('click', '#productSubscribe', function (event) {
            event.preventDefault();
            const $form = $('.subscription-form');
            const url = $(this).data('action');
            const $alert = $('.alert');
            $.ajax({
                type: 'POST',
                url: url,
                beforeSend: function () {
                    $.spinner().start();
                },
                data: $form.serialize(),
                dataType: 'json',
                success: function (data) {
                    if (data.success) {
                        // form is validated, we need to submit it to subscribe now
                        var url = $('.subscription-form-submit-url').val();
                        var source = $('.subscription-form-source').val();
                        var brand = $('.footer-form-brand').val();
                        var productid = $('.subscription-form-productid').val();

                        var obj = {
                            emailAddress: data.email,
                            source: source,
                            brand: brand,
                            productID: productid
                        };

                        $.ajax({
                            url: url,
                            type: 'GET',
                            dataType: 'json',
                            data: obj,
                            success: function (data_b) {
                                if (data_b.success) {
                                    subscriberFormReset();
                                    $alert.addClass('alert-success');
                                    showNotification(data_b, 3000);
                                } else {
                                    subscriberFormReset();
                                    $alert.addClass('alert-danger');
                                    showNotification(data_b, 3000);
                                }
                            },
                            error: function (err) {
                                subscriberFormReset();
                                $alert.addClass('alert-danger');
                                showNotification(err, 3000);
                            }
                        });
                    } else {
                        subscriberFormReset();
                        $alert.addClass('alert-danger');
                        showNotification(data, 3000);
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    hbsubmitGiftMsg: function () {
        $(document).on('submit', '.product-detail .hb-giftmsg-form', function (evt) {
            evt.preventDefault();
            let url = $(this).data('url');
            const from = $('#gmForm').val();
            const gmsg = $('#gmMsg').val();

            $(this).change(function () {
                giftMessageFormClear($(this));
            });
            if (!gmsg.length) {
                // error msg
                $('#gmMsg').addClass('is-invalid');
                $('#gmMsg').next('.invalid-feedback').text('Message field blank');
                return;
            } else if (gmsg.split('\n').length > 4) {
                // exceed error
                $('#gmMsg').addClass('is-invalid');
                $('#gmMsg').next('.invalid-feedback').text('Message has too many lines. The limit is 4');
                return;
            }

            const giftMsgObj = {
                msg: from + '|' + gmsg,
                sku: $('.set-item[data-department="chooseFriends"]').data('pid')
            };
            url = appendToUrl(url, giftMsgObj);
            $.ajax({
                url: url,
                method: 'get',
                success: function (data) {
                    if (!data.error) {
                        $('.gmFromDisplay').text(`From: ${from}`);
                        $('.gmMsgDisplay').text(gmsg);
                        $('.gmDisplay').removeClass('d-none');
                        $('#modal-gift-message').text('EDIT MESSAGE');
                    } else {
                        showNotification(data, 3000);
                    }
                    $('#modal-test').modal('hide');
                },
                error: function () {
                    // TO DO
                }
            });
        });
    },
    scentAndSoundPriceAdd: function () {
        $(document).on('click', 'input[name="heartbox-option-scent"], input[name="heartbox-option-sound"]', function () {
            const $priceContainer = $('.hb-product-set-price');
            const pdpPrice = $('[data-pricejson]').data('pricejson');
            const $allInputCont = $('input[name="heartbox-option-scent"], input[name="heartbox-option-sound"]');
            let listPrice;
            let salesPrice;
            let $listCont;
            let $salesCont;
            let totalCurrentPrice = 0;
            $allInputCont.each(function (ind, ele) {
                if ($(ele).is(':checked')) {
                    let currentPrice = parseFloat($(ele).data('price'));
                    totalCurrentPrice += currentPrice;
                }
            });
            if (pdpPrice.sales) {
                salesPrice = `${pdpPrice.sales.symbol} ${(parseFloat(pdpPrice.sales.decimalPrice) + totalCurrentPrice).toFixed(2)}`;
                $salesCont = $priceContainer.find('.sales .value');
            }
            if (pdpPrice.list) {
                listPrice = `${pdpPrice.list.symbol} ${(parseFloat(pdpPrice.list.decimalPrice) + totalCurrentPrice).toFixed(2)}`;
                $listCont = $priceContainer.find('.strike-through .value');
            }
            if ($listCont) {
                $listCont.html(listPrice);
            }
            if ($salesCont) {
                $salesCont.html(salesPrice);
            }
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),

    viewItemList: function () {
        $('body').on('DOMNodeInserted', (e) => {
            e.stopImmediatePropagation();
            if ((e.target.id == 'cq_recomm_slot-d95b9485be33ced1ea6053e67e' || e.target.id == 'cq_recomm_slot-7b462beea4468a3acfb9e5098a' || e.target.id == 'cq_recomm_slot-cf7ff529a4b2aaa1ae31091804') && isRecommadationInjected) {
                isRecommadationInjected = false;
                viewDataGTM($(e.target));
            }
        });
    }
};
